import { render, staticRenderFns } from "./SrMasterCategory.vue?vue&type=template&id=e4507266&"
import script from "./SrMasterCategory.vue?vue&type=script&lang=js&"
export * from "./SrMasterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports